import { createSlice } from "@reduxjs/toolkit";

// Récupérer le panier depuis localStorage au démarrage
const loadCartFromStorage = () => {
  try {
    const storedCart = localStorage.getItem("cart");
    return storedCart ? JSON.parse(storedCart) : [];
  } catch (error) {
    console.error("Erreur lors du chargement du panier:", error);
    return [];
  }
};

const initialState = {
  value: loadCartFromStorage(),
};

export const cartSlice = createSlice({
  name: "panier",
  initialState,
  reducers: {
    setProduct: (state, action) => {
      state.value = action.payload;
      localStorage.setItem("cart", JSON.stringify(state.value)); // Mise à jour du stockage
    },
    addProduct: (state, action) => {
      const existingProduct = state.value.find(
        (item) =>
          item.id === action.payload.id && item.weight === action.payload.weight
      );

      if (existingProduct) {
        existingProduct.quantity += 1; // ✅ Augmente la quantité
      } else {
        state.value.push({ ...action.payload, quantity: 1 }); // ✅ Nouveau produit
      }

      localStorage.setItem("cart", JSON.stringify(state.value)); // ✅ Sauvegarde
    },
    removeProduct: (state, action) => {
      state.value = state.value.filter((item) => item.id !== action.payload);
      localStorage.setItem("cart", JSON.stringify(state.value));
    },
    clearCart: (state) => {
      state.value = [];
      localStorage.removeItem("cart");
    },
  },
});

// Export des actions
export const { setProduct, addProduct, removeProduct, clearCart } =
  cartSlice.actions;

// Export du reducer
export default cartSlice.reducer;
